import { render, staticRenderFns } from "./LetrexCreate.vue?vue&type=template&id=2a5ca13b"
import script from "./LetrexCreate.vue?vue&type=script&lang=js"
export * from "./LetrexCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports